
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interviews/[interview]",
      function () {
        return require("private-next-pages/interviews/[interview]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interviews/[interview]"])
      });
    }
  